import { memo } from "react";

const DirectoriesScreen = () => {
  return <>Danh sách thư mục</>
}

export default memo(DirectoriesScreen);